/**
 * A Design Studio email in an open Automation draft, as the component and
 * global styles references lookups report it. The workspace node tree leaves
 * draft nodes out, so the row carries what the publish modals show for it.
 * Listed only with `campaign-draft-mode`.
 */
export type ReferenceDraft = {
  name: string;
  language?: string;
  draftId: string;
  /** Absent when the caller can't view Automations. */
  automationName?: string;
};

type ReferenceRow = {
  draft?: boolean | null;
  name?: string | null;
  language?: string | null;
  draft_id?: string | null;
  automation_name?: string | null;
};

/** The draft fields of a references row, or `undefined` for a live node. */
export function toReferenceDraft(row: ReferenceRow): ReferenceDraft | undefined {
  if (row.draft !== true || row.draft_id == null) {
    return undefined;
  }
  const draft: ReferenceDraft = { name: row.name ?? '', draftId: row.draft_id };
  if (row.language != null && row.language !== '') {
    draft.language = row.language;
  }
  if (row.automation_name != null && row.automation_name !== '') {
    draft.automationName = row.automation_name;
  }
  return draft;
}
